import Vue from "vue";
import Vuex from "vuex";

// Modules
import app from "./app";
import appConfig from "./app-config";
import verticalMenu from "./vertical-menu";
import config from "./config";
import parameter from "./parameter";
import auth from "./auth";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    config,
    parameter: parameter,
    auth: auth
  },
  strict: process.env.DEV
}); // ✅ Must show user object

export default store;
